import React from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import { Above } from '@jetshop/ui/Breakpoints';
import FeaturedProductCard from '../components/FeaturedProductCard';
import MaxWidth from '../../../Layout/MaxWidth';
import SectionWrapper from '../../../Layout/SectionWrapper';
import LoadingPage from '../../../LoadingPage';
import FeaturedProductQuery from '../../../ProductPage/FeaturedProduct.gql';
import { H3, H4 } from '../../../ui/Typography';
import { theme } from '../../../Theme';

const StyledMaxWidth = styled(MaxWidth)`
  max-width: 550px;
  margin: 2rem auto 3.5rem;

  ${theme.below.md} {
    margin-bottom: 1rem;
  }

  ${theme.below.sm} {
    padding: 0rem;
    margin: 0 auto;
  }

  ${H3} {
    margin-top: 0;
  }
  ${H4} {
    margin-top: 0;
    ${theme.below.sm} {
      padding: 1rem;
    }
  }
`;

const FeaturedProduct = props => {
  const { title, article_number } = props;

  const { loading, data, error } = useQuery(FeaturedProductQuery, {
    variables: { id: article_number }
  });

  if (loading) return <LoadingPage />;
  if (error) {
    console.error('Error loading featured product:', error);
    return null;
  }

  const product = data?.product;

  if (!product) return null;

  return (
    <SectionWrapper>
      <StyledMaxWidth>
        {title && (
          <Above breakpoint="sm">
            {match => (match ? <H3>{title}</H3> : <H4>{title}</H4>)}
          </Above>
        )}
        <FeaturedProductCard product={product} imageSizes={[1, 1, 550]} />
      </StyledMaxWidth>
    </SectionWrapper>
  );
};

export default FeaturedProduct;
